// Imports
import React from "react";
import RecSummary from "src/modules/RecSummary/jsx/index.jsx";
import { useQuiz } from "src/contexts/QuizContext.js";
import FocusTrap from "focus-trap-react";
import { quizInteractionTracking } from "src/modules/QuizHelpers/index.js";

const Splash = () => {
    const {
        quizStatus,
        dispatch,
        questionNo,
        questionSection,
        questions,
        snapshot,
    } = useQuiz();

    const getResumeAnswerIndex = () => {
        const qNo = snapshot?.questionNo || questionNo;
        const sNo = snapshot?.questionSection || questionSection;

        if (!qNo || !sNo) return null;

        const qKey = `question${qNo}`;
        const sKey = `section${sNo}`;
        const question = questions[qKey];
        if (!question) return null;

        const subquestion = question.subquestions?.[sKey];
        if (!subquestion) return null;

        const savedAnswer = subquestion.savedAnswer;
        if (!savedAnswer) return null;

        const options = subquestion.options || [];
        const index = options.findIndex((opt) => opt === savedAnswer);
        return index >= 0 ? index + 1 : null; // 1-based index
    };

    return quizStatus === "closed" ? (
        <FocusTrap
            active={false}
            focusTrapOptions={{
                initialFocus: false,
            }}
        >
            <div className="container container--recommendations" tabIndex={0}>
                <RecSummary
                    title="Your quiz is in progress"
                    subtitle="Click below to resume the quiz"
                />
                <div className="quiz-screen-start__button-group quiz-screen-start__button-group--splash">
                    <button
                        className="button button--large"
                        tabIndex={1}
                        onClick={(e) => {
                            e.preventDefault();

                            // Resume the quiz
                            // Use snapshot if available, otherwise use questionNo
                            let qNo = snapshot?.questionNo || questionNo;
                            let questionNumber = null;
                            let sNo = null;

                            // Only populate if we have a valid question number
                            if (qNo && qNo > 0) {
                                let qKey = `question${qNo}`;
                                // Verify the question exists - if not, use questionNo - 1
                                if (!questions[qKey] && qNo > 1) {
                                    qNo = qNo - 1;
                                    qKey = `question${qNo}`;
                                }
                                // Only set question number if question exists
                                if (questions[qKey]) {
                                    // Derive question number from the key (e.g., "question3" -> "Q3")
                                    questionNumber = qKey.replace("question", "Q");
                                    sNo = snapshot?.questionSection || questionSection;
                                    // Only set sub_question_index if it's a valid sub-question
                                    sNo = sNo && sNo > 0 ? sNo : null;
                                }
                            }

                            quizInteractionTracking({
                                interaction_type: "click",
                                question_number: questionNumber,
                                sub_question_index: sNo,
                                selected_answer_index: getResumeAnswerIndex(),
                                answer_changed: false,
                                navigation_action: "resume_quiz",
                            });

                            dispatch({
                                type: "continueQuiz",
                                payload: {
                                    questionNo,
                                    questionKey: `question${questionNo}`,
                                    questionSection,
                                },
                            });
                        }}
                    >
                        Resume the quiz
                    </button>
                    {questionNo > 1 && (
                        <button
                            onClick={(e) => {
                                e.preventDefault();

                                // Start the quiz again
                                quizInteractionTracking({
                                    interaction_type: "click",
                                    question_number: null,
                                    sub_question_index: null,
                                    selected_answer_index: null,
                                    answer_changed: false,
                                    navigation_action: "restart_quiz",
                                });

                                dispatch({
                                    type: "resetQuiz",
                                });
                            }}
                            className="button button--large"
                            tabIndex={2}
                        >
                            Start the quiz again
                        </button>
                    )}
                </div>
            </div>
        </FocusTrap>
    ) : (
        <></>
    );
};

export default Splash;
